// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"286ab31d","446":"b7af1b92","477":"c3bfd07a","719":"92b512a6","809":"e4d30ecb","849":"0789da24"}[chunkId] + ".chunk.js";
};